/** The words the filter bar and its drawer share, from the prototype's filter bar. */
export const FILTER_COPY = {
    label: 'Filters',
    none: 'Currently no active filters',
    active: (n: number) => `${n} active`,
    select: 'Select filter',
    remove: (label: string) => `Remove filter ${label}`,
    /** The same for a chip still waiting on its label, which a screen reader cannot read as "…". */
    removePending: (chipLabel: string) => `Remove filter ${chipLabel}, loading`,
    drawerTitle: 'Filters',
    apply: 'Apply filters',
    clear: 'Clear all',
    /** What a date field says before anything is picked. */
    anyDate: 'Any date',
    anyDates: 'Any dates',
    /** A chip's value while its options load, so it never reads as the id the URL carries (ALS-566). */
    pending: '…',
} as const;
